import { render } from "./MessageCreateForm.vue?vue&type=template&id=1eb9c3ff&scoped=true"
import script from "./MessageCreateForm.vue?vue&type=script&lang=js"
export * from "./MessageCreateForm.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./MessageCreateForm.vue?vue&type=style&index=1&id=1eb9c3ff&scoped=true&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb9c3ff"]])

export default __exports__